import { useQuery } from "@tanstack/react-query"
import { websiteProductService } from "@/api/websiteProductService"

export const useSimilarProducts = (id: number) => {
  return useQuery({
    queryKey: ["website-product-similar", id],
    queryFn: ({ signal }) => websiteProductService.getSimilarProducts(id, signal),
    enabled: !!id,
  })
}
